<template>
  <div>
    <a-table
      class="resourceTable custom-table scroll-hidden-table"
      row-key="id"
      :columns="columns"
      :data-source="detail.data"
      :pagination="{ pageSize: 5, total: detail.data.length, showTotal: v => `共 ${v} 条` }"
      :scroll="{ x: scrollX }"
    >
      <template slot="name" slot-scope="text, record">
        <a-tooltip placement="topLeft" :title="text">
          <a
            v-if="detailDrawerName"
            @click="$refs[detailDrawerName].show(record.id)"
          >
            {{ text }}
          </a>
          <span v-else>{{ text }}</span>
        </a-tooltip>
      </template>
      <template slot="score" slot-scope="text">
        <score-tag v-if="text >= 0" :score="text"></score-tag>
        <span v-else>不计入</span>
      </template>

      <template slot="notPassIndicators" slot-scope="text, record">
        <div v-if="record.indicators.length" style="max-height: 224px; overflow: auto">
          <div
            class="indicatorsContainer"
            v-for="(item, index) in record.indicators.filter(v => !v.pass)"
            :key="`${item.key}-${index}-${detail.source_type}`"
          >
            <a-tooltip :title="`${item.name || '-'}：${item.value}%`">
              <div class="top">
                <div class="text-overflow-multiline" style="flex: 1;">{{ item.name || '-'}}</div>
                <div style="font-weight: 500; width: 54px; text-align: right; color: #f5222d">{{ item.value }}%</div>
              </div>
            </a-tooltip>
            <a-tooltip class="bottom-tooltip" :title="item.description || '-'">
              <div class="text-overflow">描述：{{ item.description || '-' }}</div>
            </a-tooltip>
          </div>
        </div>
        <span v-else>-</span>
      </template>

      <template slot="passIndicators" slot-scope="text, record">
        <div v-if="record.indicators.length" style="max-height: 224px; overflow: auto">
          <div
            class="indicatorsContainer"
            v-for="(item, index) in record.indicators.filter(v => v.pass)"
            :key="`${item.key}-${index}-${detail.source_type}`"
          >
            <a-tooltip :title="`${item.name || '-'}：${item.value}%`">
              <div class="top">
                <div class="text-overflow-multiline" style="flex: 1;">{{ item.name || '-'}}</div>
                <div style="font-weight: 500; width: 54px; text-align: right; color: #118f15">{{ item.value }}%</div>
              </div>
            </a-tooltip>
            <a-tooltip class="bottom-tooltip" :title="item.description || '-'">
              <div class="text-overflow">描述：{{ item.description || '-' }}</div>
            </a-tooltip>
          </div>
        </div>
        <span v-else>-</span>
      </template>

      <template slot="description" slot-scope="record">
        <a-tooltip v-if="record" placement="topLeft" :title="record">
          <div class="text-overflow-multiline">{{ record }}</div>
        </a-tooltip>
        <span v-else>-</span>
      </template>
    </a-table>

    <os-drawer ref="osDetailDrawer"></os-drawer>
    <site-drawer ref="siteDetailDrawer"></site-drawer>
    <application-drawer ref="applicationDetailDrawer"></application-drawer>
    <middleware-drawer ref="middlewareDetailDrawer"></middleware-drawer>
    <database-drawer ref="databaseDetailDrawer"></database-drawer>
  </div>
</template>

<script>
import ScoreTag from '@/components/tag/ScoreTag.vue'

export default {
  name: 'ResourceTable',
  props: {
    detail: {
      type: Object
    }
  },
  components: {
    ScoreTag,
    'os-drawer': () => import('@/components/drawer/OSDrawer/index.vue'),
    SiteDrawer: () => import('@/components/drawer/SiteDrawer'),
    ApplicationDrawer: () => import('@/components/drawer/ApplicationDrawer.vue'),
    MiddlewareDrawer: () => import('@/components/drawer/MiddlewareDrawer/index.vue'),
    DatabaseDrawer: () => import('@/components/drawer/DatabaseDrawer/index.vue')
  },
  data () {
    return {
      columns: [
        {
          dataIndex: 'name',
          title: '名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'score',
          title: '分数',
          width: 100,
          scopedSlots: {
            customRender: 'score'
          },
          defaultSortOrder: 'ascend',
          sorter: true
        },
        {
          dataIndex: 'description',
          title: '原因',
          width: 200,
          scopedSlots: {
            customRender: 'description'
          }
        },
        {
          dataIndex: 'not_pass_indicators',
          title: '未通过指标',
          width: 260,
          scopedSlots: {
            customRender: 'notPassIndicators'
          }
        },
        {
          dataIndex: 'pass_indicators',
          title: '通过指标',
          width: 260,
          scopedSlots: {
            customRender: 'passIndicators'
          }
        }
      ]
    }
  },
  computed: {
    scrollX () {
      let sum = 0
      this.columns.forEach(column => {
        sum += column.width
      })
      return sum
    },
    detailDrawerName () {
      switch (this.detail.source_type) {
        case 'site':
          return 'siteDetailDrawer'
        case 'application':
          return 'applicationDetailDrawer'
        case 'middleware':
          return 'middlewareDetailDrawer'
        case 'database':
          return 'databaseDetailDrawer'
        case 'os':
          return 'osDetailDrawer'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.resourceTable {
  .indicatorsContainer {
    font-size: 12px;
    margin-bottom: 6px;
    padding: 0 16px 4px 2px;
    border-bottom: 1px solid #e8ecf3;
    .top {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-wrap: nowrap;
    }
    .bottom-tooltip {
      font-size: 11px;
      color: rgba(0, 0, 0, .55);
    }
    &:last-of-type {
      border: none;
    }
  }
}
</style>
